import React from "react";
import ReactDOM from "react-dom";
import App from "./App"; // Ensure App is properly defined in App.js

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

